import { type Account, type AccountOwner, type Organization, type RawAccount, type User } from 'shared/types'

export const findAccountOwner = function findAccountOwner(
  user: User,
  organizations: Organization[],
  account: Account | RawAccount
): AccountOwner | undefined {
  return organizations.concat(user as unknown as any).filter(babys => babys.id === account.ownerId)[0]
}
